import React, { ReactElement, useEffect, useState } from 'react'
import { RootState } from '@mindfulchefuk/types/store'
import { dateFormats } from '@mindfulchefuk/lib/dateFormats'
import { useDispatch, useSelector } from 'react-redux'

import { setDeliveryDate } from '@mindfulchefuk/actions/basketActions'
import { Calendar, calendarStyles } from '@mindfulchefuk/design-system'
import { onboardingCalendarStyles } from '@mindfulchefuk/features/Onboarding/components/Calendar/onboardingCalendar.styles'
import { useAvailableDates } from '@mindfulchefuk/features/Operations/hooks/useAvailableDates'
import { parse } from 'date-fns'

export const CalendarContainer = ({
  onDateChange,
}: {
  onDateChange?: (date: Date) => void
}): ReactElement => {
  const selectedDelivery = useSelector(
    (store: RootState) => store.basket.selectedDeliveryDate
  )
  const dispatch = useDispatch()
  const [currentDate, setCurrentDate] = useState(null)

  const {
    recipes: {
      firstAvailableDeliveryDate,
      lastAvailableDeliveryDate,
      unavailableDates,
    },
  } = useAvailableDates()

  useEffect(() => {
    setCurrentDate(parse(selectedDelivery || firstAvailableDeliveryDate))
  }, [selectedDelivery, firstAvailableDeliveryDate])

  if (!firstAvailableDeliveryDate) return null

  const tileDisabled = ({ date }: { date: Date }) => {
    const calendarDate = dateFormats.iso(date)
    return unavailableDates.includes(calendarDate)
  }
  const onChange = (date: Date) => {
    const calendarDate = dateFormats.iso(date)
    dispatch(setDeliveryDate(calendarDate))
    setCurrentDate(date)
    if (onDateChange) onDateChange(date)
  }

  return (
    <Calendar
      serializedStyles={[calendarStyles, onboardingCalendarStyles]}
      value={currentDate}
      minDate={parse(firstAvailableDeliveryDate)}
      maxDate={parse(lastAvailableDeliveryDate)}
      tileDisabled={tileDisabled}
      onChange={onChange}
    />
  )
}
